import Vue from "vue";
import VueRouter from "vue-router";
import Overview from "../views/Overview.vue";
import { AuthService } from "../services/auth-service";

Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        name: "Home",
        redirect: "/book",
    },
    {
        path: "/overview",
        name: "Overview",
        component: Overview,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/book",
        name: "Book",
        component: () => import(/* webpackChunkName: "book" */ "../views/Book.vue"),
        meta: {
            requiresAuth: true,
        },
    },
	{
        path: "/bookfilterquote",
        name: "BookFilterQuote",
        component: () => import(/* webpackChunkName: "book" */ "../views/./BookFilterQuote"),
        meta: {
            requiresAuth: true,
        },
    },
	{
        path: "/bookfilteroptions",
        name: "BookFilterOptions",
        component: () => import(/* webpackChunkName: "book" */ "../views/./BookFilterOptions"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/book/quotes/",
        name: "Quotes",
        props: true,
        component: () => import(/* webpackChunkName: "book/quotes" */ "../views/Quotes.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/book/quotes/options/",
        name: "Options",
        props: true,
        component: () => import(/* webpackChunkName: "book/options" */ "../views/Options.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/new-booking/",
        name: "New Booking",
        component: () => import(/* webpackChunkName: "rentalDetail" */ "../views/NewBooking.vue"),
        meta: {
            // requiresAuth: true, //TODO: Enable auth
        },
    },
    {
        path: "/rental/:id",
        name: "RentalDetail",
        props: true,
        component: () => import(/* webpackChunkName: "rentalDetail" */ "../views/RentalDetail.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/login",
        name: "Login",
        component: () => import(/* webpackChunkName: "authorization" */ "../views/Login.vue"),
        meta: {
            layout: "login",
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import(/* webpackChunkName: "authorization" */ "../views/Register.vue"),
        meta: {
            layout: "login",
        },
    },
    {
        path: "/applications",
        name: "Applications",
        component: () => import(/* webpackChunkName: "authorization" */ "../views/Applications.vue"),
        meta: {
            requiresAuth: true,
            requiresRole: "admin",
        },
    },
    {
        path: "/applications/:id",
        name: "ApplicationDetails",
        component: () => import(/* webpackChunkName: "authorization" */ "../views/ApplicationDetails.vue"),
        meta: {
            requiresAuth: true,
            requiresRole: "admin",
        },
    },
    {
        path: "/users",
        name: "Users",
        component: () => import(/* webpackChunkName: "authorization" */ "../views/Users.vue"),
        meta: {
            requiresAuth: true,
            requiresRole: "admin",
        },
    },
    {
        path: "/userProfile",
        name: "UserProfile",
        component: () => import(/* webpackChunkName: "authorization" */ "../views/UserProfile.vue"),
        meta: {
            requiresAuth: true,
            requiresRole: "admin",
        },
    }
];

const router = new VueRouter({
    //mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },

    routes,
});

if(process.env.VUE_APP_LOGIN=='true'){
    router.beforeEach((to, from, next) => {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
            if (AuthService.isLoggedIn()) {
                next();
                return;
            }
            next("/login");
        } else {
            next();
        }
    });
};
export default router;
